import { render, staticRenderFns } from "./DeleteRouteVersion.vue?vue&type=template&id=8b792880&"
import script from "./DeleteRouteVersion.vue?vue&type=script&lang=js&"
export * from "./DeleteRouteVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports